import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import SiteHeader from '../components/SiteHeader';
import Hero from '../components/Hero';
import EventDetails from '../components/EventDetails';
import Story from '../components/Story';
import RSVPForm from '../components/RSVPForm';
import SiteFooter from '../components/SiteFooter';

function Home() {
  const { hash } = useLocation();
  useEffect(() => {
    if (hash) requestAnimationFrame(() => document.querySelector(hash)?.scrollIntoView());
  }, [hash]);

  return (
    <div className="site-shell" id="top">
      <a className="skip-link" href="#main-content">Skip to main content</a>
      <SiteHeader />
      <main id="main-content"><Hero /><EventDetails /><Story /><RSVPForm /></main>
      <SiteFooter />
    </div>
  );
}

export default Home;
